class HelpersService {
  /**
  * Encapsulates an asynchronous function to manage the loading state (NProgress)
  * and error/alert handling.
  *
  * @param {Function} asyncFn The asynchronous function containing the request logic.
  * @param {Object} vm The Vue component instance (this).
  * @returns {Promise<void>}
  */
  async requestHandling(asyncFn, vm, message = 'request_error', title = 'operationFail') {
    if (vm.alert)
      vm.alert.message = null;

    vm.loading = true;
    NProgress.start();

    try {
      await asyncFn();
    } catch (err) {
      console.error("Erro na requisição API:", err);

      const finalMessage = typeof message === 'function' ? message(err) : message
      const finalTitle = typeof title === 'function' ? title(err) : title

      vm.$message.popup(vm, finalMessage, finalTitle, 'error');
    } finally {
      NProgress.done(true);
      vm.loading = false;
    }
  }
}

const helpersService = new HelpersService()
export default helpersService
